import styled from 'styled-components'
import { breakpoints } from '../../assets/styles/mediaBreakpoints'
import { NavLink } from 'react-router-dom'
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa'
import { EXTERNAL_LINK } from '../../assets/data/external_link'

const Footer = () => {
  return (
    <FooterContainer>
      <LinkWrapper>
        <LinkContainer>
          <FooterLinkSection>
            <FooterText $bold={true}>About Us</FooterText>
            <FooterLink to="/about">About</FooterLink>
            <FooterLink to={EXTERNAL_LINK.donate}>Donation</FooterLink>
            <FooterLink to="/superheroes">Superheroes</FooterLink>
          </FooterLinkSection>
          <FooterLinkSection>
            <FooterText $bold={true}>Help</FooterText>
            <FooterLink to="/contact">Contact Us</FooterLink>
          </FooterLinkSection>
        </LinkContainer>
        <SocialContainer>
          <FooterText $bold={true}>Follow Us</FooterText>
          <SocialLinkContainer>
            <NavLink to={EXTERNAL_LINK.cogFacebook}>
              <FaFacebook size={24} color="black" />
            </NavLink>
            <NavLink to={EXTERNAL_LINK.cogInstagram}>
              <FaInstagram size={24} color="black" />
            </NavLink>
            <NavLink to={EXTERNAL_LINK.cogYoutube}>
              <FaYoutube size={24} color="black" />
            </NavLink>
            <NavLink to={EXTERNAL_LINK.cogLinkein}>
              <FaLinkedin size={24} color="black" />
            </NavLink>
          </SocialLinkContainer>
        </SocialContainer>
      </LinkWrapper>
      <LineBreak />
      <LinkWrapper $gap="32px" $flexDirection="column-reverse">
        <FooterText>©2024 Community of Guardians</FooterText>
        <TnCContainer>
          <FooterLink to="">Privacy Policy</FooterLink>
          <FooterLink to="">Terms & Conditions</FooterLink>
        </TnCContainer>
      </LinkWrapper>
    </FooterContainer>
  )
}

const FooterContainer = styled.div`
  padding: 80px 64px 32px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (max-width: ${breakpoints.desktop}px) {
    padding: 64px 24px 32px;
  }
`
const LinkWrapper = styled.div.attrs<{
  $gap?: string
  $flexDirection?: string
}>((props) => ({
  $gap: props.$gap || '48px',
  $flexDirection: props.$flexDirection || 'column',
}))`
  display: flex;
  justify-content: space-between;
  @media (max-width: ${breakpoints.desktop}px) {
    flex-direction: ${(props) => props.$flexDirection};
    gap: ${(props) => props.$gap};
    text-align: center;
  }
`
const LineBreak = styled.hr`
  width: 100%;
  color: ${(props) => props.theme.colors['gray-200']};
`
const LinkContainer = styled.div`
  display: flex;
  gap: 120px;
  @media (max-width: ${breakpoints.desktop}px) {
    flex-direction: column;
    gap: 40px;
  }
`
const FooterText = styled.p.attrs<{ $bold?: boolean }>((props) => ({
  $bold: props.$bold ?? false,
}))`
  font-size: 16px;
  font-weight: ${(props) => (props.$bold ? 'bold' : 'normal')};
`
const FooterLinkSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const FooterLink = styled(NavLink)`
  font-size: 16px;
  color: ${(props) => props.theme.colors['gray-500']};
  text-decoration: none;
`
const SocialContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
const SocialLinkContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 40px;
`
const TnCContainer = styled.div`
  display: flex;
  gap: 24px;
  @media (max-width: ${breakpoints.desktop}px) {
    width: 100%;
    justify-content: center;
  }
`

export default Footer
